import{i as n}from"./isFunction-8a46d21f.js";import{i as r}from"./isLength-33278827.js";var t=function(n){return function(r){return n(r)}};var i=function(t){return null!=t&&r(t.length)&&!n(t)};export{t as _,i};
//# sourceMappingURL=isArrayLike-f5e8e907.js.map
